import { jsonMember, jsonObject } from 'typedjson';
import { AdminSubscriptionContextOperationsResponse } from './admin-subscription-context-operations.response';
import { Guid, Nillable } from '@web/utils';
import {
  SubscriptionNumber,
  SubscriptionStatus,
} from '@web/shared/module/shop';
import { AdminSubscriptionSubscriberResponse } from './admin-subscription-subscriber.response';

@jsonObject
export class AdminSubscriptionCollectionItemResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(Boolean)
  public readonly isLocked!: boolean;

  @jsonMember(String)
  public readonly number!: SubscriptionNumber;

  @jsonMember(String)
  public readonly status!: SubscriptionStatus;

  @jsonMember(Number)
  public readonly totalPrice!: number;

  @jsonMember(Date)
  public readonly nextPaymentDate?: Nillable<Date>;

  @jsonMember(Date)
  public readonly secondPaymentDate?: Nillable<Date>;

  @jsonMember(Date)
  public readonly thirdPaymentDate?: Nillable<Date>;

  @jsonMember(Date)
  public readonly lastPaymentDate!: Date;

  @jsonMember(String)
  public readonly cardExpiryDate?: string;

  @jsonMember(String)
  public readonly cardNumber?: string;

  @jsonMember(Date)
  public readonly createdAt!: Date;

  @jsonMember(AdminSubscriptionSubscriberResponse)
  public readonly subscriber!: AdminSubscriptionSubscriberResponse;

  @jsonMember(AdminSubscriptionContextOperationsResponse)
  public readonly contextOperations!: AdminSubscriptionContextOperationsResponse;
}
